const COMPARE_SEPARATOR = '-vs-';

export const getBoardCompareIdentifier = (boardOrIdentifier) => {
  if (boardOrIdentifier && typeof boardOrIdentifier === 'object') {
    return String(boardOrIdentifier.slug || boardOrIdentifier.id || '').trim();
  }

  return String(boardOrIdentifier ?? '').trim();
};

export const findBoardByCompareIdentifier = (boards = [], identifier = '') => {
  const normalizedIdentifier = String(identifier ?? '').trim();

  if (!normalizedIdentifier) {
    return null;
  }

  return boards.find((board) => (
    String(board?.id ?? '') === normalizedIdentifier
    || String(board?.slug ?? '') === normalizedIdentifier
  )) || null;
};

export const resolveCompareBoardSelection = (selectedIdentifiers = [], boards = []) => (
  selectedIdentifiers.map((identifier) => findBoardByCompareIdentifier(boards, identifier) || identifier)
);

export const buildCompareBoardIdentifiers = (boardsOrIdentifiers = []) => (
  boardsOrIdentifiers
    .map(getBoardCompareIdentifier)
    .filter(Boolean)
    .slice(0, 2)
);

export const buildComparePath = (boardsOrIdentifiers = []) => {
  const identifiers = buildCompareBoardIdentifiers(boardsOrIdentifiers);

  if (identifiers.length === 0) {
    return '/compare';
  }

  return `/compare?${identifiers.map(encodeURIComponent).join(COMPARE_SEPARATOR)}`;
};

export const parseCompareBoardIdentifiersFromSearch = (search = '') => {
  const rawSearch = String(search || '').replace(/^\?/, '').trim();

  if (!rawSearch) {
    return [];
  }

  if (!rawSearch.includes('=')) {
    return rawSearch
      .split(COMPARE_SEPARATOR)
      .map((identifier) => decodeURIComponent(identifier).trim())
      .filter(Boolean)
      .slice(0, 2);
  }

  const searchParams = new URLSearchParams(rawSearch);
  const identifiersParam = searchParams.get('boards') || searchParams.get('ids') || '';

  return identifiersParam
    .split(',')
    .map((identifier) => identifier.trim())
    .filter(Boolean)
    .slice(0, 2);
};
